"use client";
import { Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";

import Blue_Btn from "../../common_btn/blue_btn/Blue_Btn";
import "./Address_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Green_round_btn from "../../common_btn/green_round_btn/Green_round_btn";
import {
  createOrderAddress,
  EditOrderAddress,
  getAllOrderAddress,
  getSingleOrderAddress,
} from "../../../../features/order/orderSlice";
import {
  AllCity,
  AllPincode,
  AllState,
  getAllCountries,
} from "../../../../features/master/masterSlice";
import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { deleteUserAddress } from "../../../../features/user/userSlice";
import Success_Modal from "../success_modal/Success_Modal";

const Address_Modal = ({ id, isUpdate, onSuccess, ...props }) => {
  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    register,
    reset,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });

  const countries = useSelector((state) => state.master.all_country);
  const states = useSelector((state) => state.master.all_state);
  const cities = useSelector((state) => state.master.all_city);
  const pincodes = useSelector((state) => state.master.all_pincode);

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  const handleCountryChange = (selectedOption) => {
    setValue("country_id", selectedOption?.value);
    setValue("state_id", null);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllState({ countryId: selectedOption.value }));
  };

  const handleStateChange = (selectedOption) => {
    setValue("state_id", selectedOption.value);
    setValue("city_id", null);
    setValue("pincode_id", null);
    dispatch(AllCity({ stateId: selectedOption.value }));
  };

  const handleCityChange = (selectedOption) => {
    setValue("city_id", selectedOption?.value);
    setValue("pincode_id", null);
    dispatch(AllPincode({ cityId: selectedOption.value }));
  };

  const handlePincodeChange = (selectedOption) => {
    setValue("pincode_id", selectedOption?.value);
  };

  const onSubmit = async (data) => {
    const DataToSend = new FormData();

    DataToSend.append("country_id", data?.country_id?.value);
    DataToSend.append("state_id", data?.state_id?.value);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id?.value);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id?.value);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);

    const res = await dispatch(createOrderAddress({ data: DataToSend }));

    if (res?.meta?.requestStatus === "fulfilled") {
      reset({
        country_id: null,
        state_id: null,
        name: "",
        pincode_id: null,
        street: "",
        building: "",
        city_id: null,
        contact_no: "",
        landmark: "",
      });

      await dispatch(getAllOrderAddress());

      // Tell Personal_Info that address was successfully saved
      onSuccess?.();
    }
  };
  // const onSubmit = async (data) => {
  //   const DataToSend = new FormData();
  //   DataToSend.append("country_id", data?.country_id?.value);
  //   DataToSend.append("state_id", data?.state_id?.value);
  //   DataToSend.append("first_name", data?.name);
  //   DataToSend.append("pincode_id", data?.pincode_id?.value);
  //   DataToSend.append("street", data?.street);
  //   DataToSend.append("building", data?.building);
  //   DataToSend.append("city_id", data?.city_id?.value);
  //   DataToSend.append("contact_no", data?.contact_no);
  //   DataToSend.append("apartment", data?.landmark);
  //   const res = await dispatch(createOrderAddress({ data: DataToSend }));
  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setShowSucsessModal(true);
  //     setTimeout(() => {
  //       setShowSucsessModal(false);
  //       reset({
  //         country_id: null,
  //         state_id: null,
  //         name: "",
  //         pincode_id: null,
  //         street: "",
  //         building: "",
  //         city_id: null,
  //         contact_no: "",
  //         landmark: "",
  //       });
  //     }, 3000);
  //     props?.onHide();
  //   } else if (res.meta?.requestStatus === "rejected") {
  //   }

  //   await dispatch(getAllOrderAddress());
  // };

  const handleEdit = async (id) => {
    const res = await dispatch(getSingleOrderAddress({ id }));
    if (res?.payload?.success) {
      reset(res.payload.data);
    }
  };

  useEffect(() => {
    if (id) {
      handleEdit(id);
    }
  }, [isUpdate]);

  const handleUpdate = async (data) => {
    const DataToSend = new FormData();

    DataToSend.append("country_id", data?.country_id?.value);
    DataToSend.append("state_id", data?.state_id?.value);
    DataToSend.append("first_name", data?.name);
    DataToSend.append("pincode_id", data?.pincode_id?.value);
    DataToSend.append("street", data?.street);
    DataToSend.append("building", data?.building);
    DataToSend.append("city_id", data?.city_id?.value);
    DataToSend.append("contact_no", data?.contact_no);
    DataToSend.append("apartment", data?.landmark);

    const res = await dispatch(
      EditOrderAddress({
        id,
        data: DataToSend,
      }),
    );

    if (res?.meta?.requestStatus === "fulfilled") {
      reset({
        country_id: null,
        state_id: null,
        name: "",
        pincode_id: null,
        street: "",
        building: "",
        city_id: null,
        contact_no: "",
        landmark: "",
      });

      await dispatch(getAllOrderAddress());

      // Tell Personal_Info that address was successfully updated
      onSuccess?.();
    }
  };
  // const handleUpdate = async (data) => {
  //   const DataToSend = new FormData();
  //   DataToSend.append("country_id", data?.country_id?.value);
  //   DataToSend.append("state_id", data?.state_id?.value);
  //   DataToSend.append("first_name", data?.name);
  //   DataToSend.append("pincode_id", data?.pincode_id?.value);
  //   DataToSend.append("street", data?.street);
  //   DataToSend.append("building", data?.building);
  //   DataToSend.append("city_id", data?.city_id?.value);
  //   DataToSend.append("contact_no", data?.contact_no);
  //   DataToSend.append("apartment", data?.landmark);
  //   const res = await dispatch(EditOrderAddress({ id, data: DataToSend }));

  //   if (res.meta?.requestStatus === "fulfilled") {
  //     setShowSucsessModal(true);
  //     setTimeout(() => {
  //       setShowSucsessModal(false);
  //       reset({
  //         country_id: null,
  //         state_id: null,
  //         name: "",
  //         pincode_id: null,
  //         street: "",
  //         building: "",
  //         city_id: null,
  //         contact_no: "",
  //         landmark: "",
  //       });
  //       props?.onHide();
  //     }, 3000);
  //   } else if (res.meta?.requestStatus === "rejected") {
  //   }
  // };

  return (
    <Modal className="Address_Modal" size="lg" centered {...props}>
      <Modal.Body>
        <div className="address_form_div">
          <div className="close-btn" onClick={props?.onHide}>
            <FontAwesomeIcon icon={faXmark} />
          </div>
          <Form>
            <div className="row">
              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Full Name *</Form.Label>

                  <Form.Control
                    {...register("name", {
                      required: "Full name is required",
                    })}
                    placeholder="Enter your name"
                  />
                  {errors.name && (
                    <p className="error__feedback">{errors.name.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Country / Region</Form.Label>
                  <Controller
                    className="Select_Dropdown_holder"
                    name="country_id" // Form field name
                    control={control}
                    placeholder="Enter your name"
                    rules={{ required: "Country is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countries}
                        placeholder="Select Country / Region"
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          // GetAllStates(selectedOption.value);
                          handleCountryChange(selectedOption);
                          setValue("country_id", selectedOption);
                          // setValue("state_id", null);
                          // setValue("city_id", null);
                          // clearErrors("country_id");
                        }}
                      />
                    )}
                  />
                  {errors.country_id && (
                    <p className="error__feedback">
                      {errors.country_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>
              <div className="col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>State</Form.Label>
                  <Controller
                    className="Select_Dropdown_holder"
                    name="state_id" // Form field name
                    control={control}
                    rules={{ required: "State is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={states}
                        placeholder="Select State"
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handleStateChange(selectedOption);
                          setValue("state_id", selectedOption);
                          setValue("city_id", null);
                          // clearErrors("country_id");
                        }}
                      />
                    )}
                  />
                  {errors.state_id && (
                    <p className="error__feedback">{errors.state_id.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>City</Form.Label>
                  <Controller
                    className="Select_Dropdown_holder"
                    name="city_id" // Form field name
                    control={control}
                    rules={{ required: "City is required" }}
                    render={({ field }) => (
                      // <Select
                      //   styles={{
                      //     control: (baseStyles) => ({
                      //       ...baseStyles,
                      //       borderColor: errors.country_id
                      //         ? "red"
                      //         : baseStyles,
                      //     }),
                      //   }}
                      //   {...field}
                      //   options={cities}
                      //   onChange={(selectedOption) => {
                      //     field.onChange(selectedOption.value); // Update Controller's value
                      //     // GetAllStates(selectedOption.value);
                      //     handleCityChange(selectedOption);
                      //     // clearErrors("country_id");
                      //   }}
                      // />

                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={cities}
                                           placeholder="Select City"
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handleCityChange(selectedOption);
                          setValue("city_id", selectedOption);
                          // setValue("city_id", null);
                          // clearErrors("country_id");
                        }}
                      />
                    )}
                  />
                  {errors.city_id && (
                    <p className="error__feedback">{errors.city_id.message}</p>
                  )}
                </Form.Group>
              </div>
              <div className="col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Pincode</Form.Label>
                  <Controller
                    className="Select_Dropdown_holder"
                    name="pincode_id" // Form field name
                    control={control}
                    rules={{ required: "Pincode is required" }}
                    render={({ field }) => (
                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            borderColor: errors.country_id ? "red" : baseStyles,
                          }),
                        }}
                        {...field}
                        options={pincodes}
                                placeholder="Select Pincode"
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption.value); // Update Controller's value
                          handlePincodeChange(selectedOption);

                          setValue("pincode_id", selectedOption);
                        }}
                      />
                    )}
                  />
                  {errors.pincode_id && (
                    <p className="error__feedback">
                      {errors.pincode_id.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="col-sm-6">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Contact *</Form.Label>
                  <Controller
                    name="contact_no"
                    control={control}
                    rules={{ required: "Contact is required" }}
                    render={({ field }) => (
                      <PhoneInput
                        {...field}
                        country="in"
                        onChange={(value) => field.onChange(value)}
                        inputClass="form-control"
                      />
                    )}
                  />
                  {errors.contact_no && (
                    <p className="error__feedback">
                      {errors.contact_no.message}
                    </p>
                  )}
                </Form.Group>
              </div>

              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>
                    Flat, House No., Building, Company, Apartment
                  </Form.Label>
                  <Form.Control
                    {...register("building", {
                      required: "Address line is required",
                    })}
                    placeholder="Enter Landmark"
                  />
                  {errors.building && (
                    <p className="error__feedback">{errors.building.message}</p>
                  )}
                </Form.Group>
              </div>

              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Area, Street, Sector, Village</Form.Label>
                  <Form.Control
                    type="text"
                    name="street"
                    placeholder="Enter Address"
                    {...register("street")}
                  />
                </Form.Group>
              </div>

              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Landmark</Form.Label>
                  <Form.Control
                    type="text"
                    name="landmark"
                    placeholder="Enter Address"
                    {...register("landmark")}
                  />
                </Form.Group>
              </div>

              {/* 
              <div className="">
                <Form.Group
                  className="input_group"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Check
                    type="checkbox"
                    label="Make this my default address"
                    name="timeframe"
                    value="Male"
                    className="custom-radio-green"
                  />
                </Form.Group>
              </div> */}
            </div>
            <div className="btn_holder text-center mt-4">
              {isUpdate ? (
                <div className="save_btn">
                  <Blue_Btn
                    btnText="Update Address"
                    onClick={handleSubmit(handleUpdate)}
                  />
                </div>
              ) : (
                <div className="save_btn">
                  <Blue_Btn
                    btnText="Save Address"
                    onClick={handleSubmit(onSubmit)}
                  />
                </div>
              )}
            </div>
          </Form>
        </div>
      </Modal.Body>

      <Success_Modal
        show={showSuccessModal}
        onHide={() => setShowSucsessModal(false)}
        successText={
          !isUpdate
            ? "Address Saved Successfully!"
            : "Address Updated Successfully!"
        }
      />
    </Modal>
  );
};

export default Address_Modal;
